import { prop, compose } from 'ramda';

import { Reason } from 'packages/rum';
import createError from 'app/error/createError';

const extractData = prop('data');

const interpretData = data => {
  if (data.error) {
    throw createError({ reason: Reason.Api, ...data.error });
  }
  return data;
};

const parseResponse = compose(interpretData, extractData);

export default parseResponse;

export { extractData };
